import './InteractPane.scss'
import { useSearchParams } from 'react-router'
import { Filters } from '../Filters'
import { Button } from '@/ui-legacy'
import { useFooterHeight } from '@/hooks'
import { usePageFilters } from '@/contexts/PageFilterContext/PageFilterContextProvider2'
import { AppLink } from '../Link'
import { DismissRegular } from '@fluentui/react-icons'

export function InteractPane() {
  const [searchParams] = useSearchParams()

  const paneKey = searchParams.get('interact') ?? null

  const { pageFilters, updatePageFilters, resetPageFilters, selectClear, multiSelect, multiClearAll, multiSelectAll } =
    usePageFilters()
  const footerHeight = useFooterHeight()
  const headerHeight = 43

  const classes = ['ux-interact-pane h-[calc(100vh-86px)] box-border', (!paneKey || paneKey !== 'filters') && 'hidden']
    .filter(Boolean)
    .join(' ')

  const toggleButton = (
    <AppLink
      toggleParams={[
        {
          key: 'interact',
          value: 'filters',
          __typename: 'Param',
        },
      ]}
      __typename="NavLink"
    >
      <div className="flex size-8 items-center justify-center justify-self-end text-foreground/50 hover:border-primary hover:text-primary">
        <DismissRegular fontSize={20} />
      </div>
    </AppLink>
  )

  if (!pageFilters || pageFilters.length === 0) {
    return (
      <div className={classes}>
        <header>
          <div>
            <span>Filters</span>
          </div>
          {toggleButton}
        </header>
        <div className="no-filter">
          <span>No filters</span>
        </div>
      </div>
    )
  }

  // TODO switch (paneKey) ...
  //    - delegate to specialised panes (FilterPane, ScenarioPane, etc)
  //    - OR define generic capability to create custom panes (e.g. using Forms)

  return (
    <div className={classes} style={{ height: `calc(100vh - ${footerHeight}px - ${headerHeight}px)` }}>
      <header>
        <div>
          <span>Filters</span>
        </div>
        {toggleButton}
      </header>
      {pageFilters && pageFilters.length > 0 && (
        <div className="scrollable">
          <Filters
            filters={pageFilters}
            updateFilters={updatePageFilters}
            primaryFilters={false}
            selectClear={selectClear}
            multiSelect={multiSelect}
            multiClearAll={multiClearAll}
            multiSelectAll={multiSelectAll}
          />
        </div>
      )}
      <div className="button-container">
        <Button text="Reset filters" onClick={resetPageFilters} />
      </div>
    </div>
  )
}
